module.exports = __webpack_public_path__ + "img/aeroland-payment-box-icon-05.844a577b.png";